// 验证手机号码
export function validPhone(str) {
  // return /^1[3|4|5|7|8|9|6][0-9]\d{8}$/.test(str)
  return /^1[0-9][0-9]\d{8}$/.test(str)
}

// 验证姓名
export function vaildName(str) {
  return /^.{2,15}$/.test(str)
}

// 验证统一社会信用代码
export function vaildSocialCreditCode(str) {
  return /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/.test(str)
}

// 验证密码
export function validPassword(str) {
  return /^[a-zA-Z0-9_-]{6,16}$/.test(str)
}

// 验证正整数
export function validInteger(str) {
  return /^[0-9]+$/.test(str)
}

// 验证金额
export function validAmount(str) {
  return /(?:^[1-9]([0-9]+)?(?:\.[0-9]{1,2})?$)|(?:^(?:0)$)|(?:^[0-9]\.[0-9](?:[0-9])?$)/.test(str)
}

// 银行账户
export function bankCard(str) {
  return /^[1-9]\d{9,29}$/.test(str)
}


// 验证后台订单号
export function validBackstageOrderNo(str) {
  return (/^6[0-9]{18}$/).test(str)
}
